import React from "react";
import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  Alert,
  Tabs,
  Tab,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, range } from "lodash";
import { Grid } from "../../../components/table";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { ToolBar } from "../../../components/toolbar";
import { Modal } from "../../../components/modal";
import { FormA } from "../../../components/form";
import moment from "moment";
import { getFormState } from "../../../../helpers/form";
import dayjs from "dayjs";
import { Pendingfollowups } from "./pending-followups";
import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from "prop-types";
import BoltIcon from "@mui/icons-material/Bolt";
import { filterColumns } from "../column-manager";
import useModalState from "../../../../hooks/use-modal-state";
import SelectedAssignDialog from "../master-database/features/selected-assign-dialog";
// Removed ArrowOutwardIcon and toast as they are no longer used here for the dialog
const durationPulgin = require("dayjs/plugin/duration");
dayjs.extend(durationPulgin);

const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const getTotalWeekOfCurrentMonth = () => {
  return Math.ceil(dayjs().daysInMonth() / 7);
};

const getWeekOfMonth = () => {
  return dayjs.duration().weeks();
};

export const Pending = (props) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="PREVIOUSLY UNREACHED" {...a11yProps(0)} />
          <Tab label="NEW DATA" {...a11yProps(1)} />
          <Tab label="FOLLOW UP" {...a11yProps(2)} />
          {/* <Tab label="INBOUND DATA" {...a11yProps(3)} /> */}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <List
          heading={""}
          sx={{ fontSize: ".1em" }}
          type={"previously-unreached"}
          socket={props.socket}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <List heading={""} type={"newdata"} socket={props.socket} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2} socket={props.socket}>
        <Pendingfollowups />
      </CustomTabPanel>
      {/* <CustomTabPanel value={value} index={3}  >
				<List heading={'Inbound List'} type={'inbound'} />
			</CustomTabPanel> */}
    </Box>
  );
};

export const List = ({ heading, type, socket }) => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    map,
  } = useSelector((state) => state.user || {});
  const userStore = useSelector((state) => state.user || {});
  console.log("length", dayjs.duration().asWeeks());


  // Removed states previously added for SelectedAssignDialog

  const [staticSelectedRows, setStaticSelectedRows] = useState(new Map()); // Keep this for grid selection
  const [activeSelectedAssign, setActiveSelectedAssign] = useState(null); // Keep this for potential future use or remove if unused


  const [active, setActive] = useState("Employees");
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState("new");
  const [saved, setSaved] = useState(null);
  const [index, setIndex] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const [assignCompleted, setAssignCompleted] = useState(false);

  // state for opening selective assigning dialog
  const {
    isOpen: isSelectiveAssigningModalOpen,
    openModal: openSelectiveAssigningModal,
    closeModal: closeSelectiveAssigningModal,
    data: selectiveAssigningModalData,
    setData: setSelectiveAssigningModalData,
  } = useModalState();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [count, setCount] = useState(0);
  const [selectedSankalpData, setSelectedSankalpData] = useState(null);
  const [filter, setFilter] = useState({
    from: null, // dayjs("01-01-2023"),
    to: null, //dayjs(),
    cfrom: null,
    cto: null,


    // district: "Any",
    week: getWeekOfMonth(),
  });

  useEffect(() => {
    console.log(filter);
  }, [filter]);

  useEffect(() => {
    if (socket) {
      socket.on("case-update", (data) => {
        getList(true);
      })
    }
    return () => {
      if (socket) {
        socket.removeAllListeners();
      }
    }
  }, [socket])

  // Removed methods previously added for SelectedAssignDialog


  const getList = (keep) => {
    if (!keep) {
      setData([]);
      setStaticSelectedRows(new Map()); // Clear selection when list is cleared
    }
    axios
      .get(
        API_HOST_CRM +
        `/cases?limit=${rowsPerPage}` +
        `&page=${page}&type=${type}` +
        `${filter.from
          ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
          : ""
        }` +
        `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
        `${filter.status ? `&status=${encodeURIComponent(JSON.stringify(filter.status))}` : ""}` +
        `${filter.districtName ? `&district=${encodeURIComponent(JSON.stringify(filter.districtName))}` : ""}` +
        `${filter.dataType ? `&dataType=${encodeURIComponent(JSON.stringify(filter.dataType))}` : ""}` +
        `${filter.motherID ? `&motherId=${filter.motherID}` : ""}` +
        `${filter.motherName ? `&motherName=${filter.motherName}` : ""}` +
        `${filter.contact ? `&contact=${filter.contact}` : ""}` +
        // `${filter.motherStatus ? `&motherStatus=${filter.motherStatus}` : ""}` +
        `${filter.motherStatus ? `&motherStatus=${encodeURIComponent(JSON.stringify(filter.motherStatus))}` : ""}` +
        // `${filter.telecaller ? `&telecaller=${filter.telecaller}` : ""}` +
        `${filter.telecaller ? `&telecaller=${encodeURIComponent(JSON.stringify(filter.telecaller))}` : ""}` +
        `${filter.nextCallDue ? `&nextCallDue=${filter.nextCallDue}` : ""}` +
        `${filter.allocatedToUser ? `&allocatedToUser=${encodeURIComponent(JSON.stringify(filter.allocatedToUser))}` : ""}` +

        `${filter.dateReceived ? `&dateReceived=${filter.dateReceived}` : ""
        }` +

        `${filter.lastCallDate ? `&lastCallDate=${filter.lastCallDate}` : ""
        }` +
        `${filter.callDate ? `&callDate=${filter.callDate}` : ""
        }` +
        `${filter.lastAttemptDate ? `&lastAttemptDate=${filter.lastAttemptDate}` : ""
        }` +
        `${filter.cfrom
          ? `&cfrom=${dayjs(filter.cfrom).format("YYYY-MM-DD")}`
          : ""
        }` +
        `${filter.cto ? `&cto=${dayjs(filter.cto).format("YYYY-MM-DD")}` : ""
        }` +
        `${filter.week ? `&week=${filter.week}` : ""}` +
        `${filter.priority ? `&priority=${encodeURIComponent(JSON.stringify(filter.priority))}` : ""}`
        +
        `${filter.uploadTypeDelivery ? `&uploadTypeDelivery=${filter.uploadTypeDelivery}` : ""}`
      )
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setData(resp.data.cases);
          setCount(resp.data.count);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    getList();
  }, [page, rowsPerPage, filter]);

  useEffect(() => {
    getList();
  }, []);

  const exportMotherReport = (data) => {
    axios
      .get(
        API_HOST_CRM +
        `/export-motherData?id=${data.motherID}&from=${encodeURIComponent(
          dayjs(filter.from).format("YYYY-MM-DD")
        )}&to=${encodeURIComponent(dayjs(filter.to).format("YYYY-MM-DD"))}
				
				`,
        {
          responseType: "arraybuffer",
        }
      )
      .then((resp) => {
        if (resp) {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Mother_Report_${data.motherID}+${data.name}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          console.log(resp);
          link.remove();
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <ToolBar
        name={heading}
        height={"3em"}
        buttons={[
          // {
          //   name: assignCompleted
          //     ? "Assign Completed"
          //     : assigning
          //     ? "Assigning....."
          //     : "Assign AUTO",
          //   // type: 'chip',
          //   icon: () => <BoltIcon sx={{ fontSize: "1.2em" }} />,
          //   onClick: () => {
          //     if (!assigning && !assignCompleted) {
          //       setAssigning(true);
          //       axios
          //         .get(API_HOST_CRM + "/allocate-auto")
          //         .then((resp) => {
          //           if (resp.data && resp.data.success) {
          //             setAssigning(false);
          //             setAssignCompleted(true);
          //             setTimeout(() => {
          //               setAssignCompleted(false);
          //             }, 2000);
          //           }
          //           setAssigning(false);
          //         })
          //         .catch((e) => {
          //           console.log(e);
          //           setAssigning(false);
          //         });
          //     }
          //   },
          // },
          // Removed the "Assign Selected" button logic related to the dialog
          // Add a different button or logic if needed for this specific 'pending' list
        ]}
        onClearFilter={() => {
          setFilter({
            from: null,
            to: null,
            cfrom: null,
            cto: null,
            firstReceived: null,
            motherName: "",
            motherID: "",
            contact: "",
            status: null,
            motherStatus: null,
            telecaller: null,
            district: null,
          });
        }}
        filters={[
          {

            minWidth: 150,
            field: {
              name: "uploadTypeDelivery",
              type: "select",
              label: "Upload Type Delivery",
              option: { key: "UploadTypeDelivery", value: "_id", label: "name" },
              noMb: true,
            },
            data: {
              UploadTypeDelivery: ["any", "yes", "no"].map(
                (d) =>
                  d === "Any" ? { _id: "", name: "Any" } : { _id: d, name: d }
              ),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,

          },
          {
            minWidth: 150,
            field: {
              name: "typeNewData",
              type: "select",
              label: "Type of New Data",
              option: { key: "NewDataType", value: "_id", label: "name" },
              noMb: true,
            },
            data: {
              NewDataType: ["Any", "Fresh Data", "Previously Attempted"].map(
                (d) =>
                  d === "Any" ? { _id: "", name: "Any" } : { _id: d, name: d }
              ),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          {
            field: {
              name: "from",
              type: "date",
              label: "Assign From",
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          {
            field: {
              name: "to",
              type: "date",
              label: "Assign To",
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
        ]}
      />
      <Box sx={{ mt: 2 }}>
        <Grid
          staticSelectedRows={staticSelectedRows} // Keep passing selection state to Grid
          setStaticSelectedRows={setStaticSelectedRows} // Keep passing setter to Grid
          data={data}
          // filter={filter}
          columns={[
            ...filterColumns(
              [
                {
                  id: "motherID",
                  showFilter: true,
                },
                {
                  id: "name",
                  showFilter: true,
                },
                {
                  id: "contact",
                  showFilter: true,
                },
                {
                  id: "districtName",
                  type: "select",
                  showFilter: true
                },
                {
                  id: "dateReceived",
                  showFilter: true,
                  minWidth: 150,
                },
                {
                  id: "lastCallDate",
                  showFilter: true,
                  minWidth: 150,
                },
                {
                  id: "allocatedToUser",
                  showFilter: true,
                  type: "select",
                  minWidth: 150,
                },
                {
                  id: "callDate",
                  showFilter: true,
                  minWidth: 150,
                },
                {
                  id: "lastCall",
                  showFilter: true
                },
                ...[(!["newdata"].includes(type) ? {
                  id: "status",
                  showFilter: true,
                  type: "select",
                  minWidth: 150,
                } : {})],
                {
                  id: "comments",
                  showFilter: true
                },
                {
                  id: "lastAttemptDate",
                  showFilter: true,
                  minWidth: 150,
                },
                {
                  id: "nextCallDue",
                  showFilter: true,
                  minWidth: 150,
                }
              ],
              filter,
              setFilter,
              { Districts, users, map }
            ),
          ]}
          pagination={{
            rowsPerPageOptions: [10, 25, 50],
            page,
            rowsPerPage,
            onPageChange: (event, newPage) => {
              setPage(newPage);
            },
            onRowsPerPageChange: (event) => {
              setRowsPerPage(+event.target.value);
              setPage(0);
            },
            count,
          }}
        ></Grid>
      </Box>

      {/* Removed the SelectedAssignDialog instance as its functionality is moved to assigned.js */}

      <Modal
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        head={`Sankalp Data`}
        buttons={[
          {
            name: "Cancel",
            onClick: () => {
              setOpen(false);
            },
          },
        ]}
      >
        {selectedSankalpData &&
          selectedSankalpData.sankalpData &&
          Object.keys(selectedSankalpData.sankalpData).map((s, i) => {
            const map = {
              pregStatus: "Pregnancy Status",
              advice: "Advice",
              pregnancyNumber: "Pregnancy Number",
              pretermDelivery: "Pre-term Delivery",
              nearResidance: "Near By Residence",
              trimester: "Trimester",
            };
            return (
              <Box key={i} sx={{ display: "flex", mt: 1 }}>
                <Typography variant="p">{map[s] || s}: </Typography>&nbsp;
                <Typography
                  variant="p"
                  sx={{ color: "grey", fontSize: ".9em" }}
                >
                  {selectedSankalpData.sankalpData[s]}
                </Typography>
              </Box>
            );
          })}
      </Modal>
    </>
  );
};
